module.exports = __webpack_public_path__ + "fonts/Nunito-400-vietnamese3.6a8bc7a.woff2";